import { ShowItem, ItemManager } from "./showItem";
import { ReactNode } from 'react';
import { ReactComponent as CuteIcon } from '../svg/cute.svg';
import { ReactComponent as IVUProstatitiIcon } from '../svg/ivu_prostatiti.svg';
import { ReactComponent as InfezioniOculariIcon } from '../svg/infezioni_oculari.svg';
import { ReactComponent as InfezioniSessualmenteTrasmissibiliIcon } from '../svg/infezioni_sessualmente_trasmissibili.svg';
import { ReactComponent as InfezioniBasseVieAereeIcon } from '../svg/infezioni_basse_vie_aeree.svg';
import { ReactComponent as AlteVieRespiratorieIcon } from '../svg/alte_vie_respiratorie.svg';
import { ReactComponent as OtitiIcon } from '../svg/otiti.svg';
import { ReactComponent as ORLIcon } from '../svg/orl.svg';
import { ReactComponent as OtherIcon } from '../svg/other.svg';
import { textColor } from "../utils/avatar";
import { colors } from "../theme";

export class Pathology implements ShowItem {
    code: string;
    title: string;
    definition: string;
    eziologia: string;
    quadroClinico: string;
    diagnosi: string;
    terapia: string;
    distrettoAnatomico: string;
    notes: string;

    constructor(csvArray: string[]) {
        if(csvArray.length !== 9) {
            throw new Error(`Invalid CSV array length for Pathology: ${csvArray.length}`);
        }

        this.code = csvArray[0];
        this.title = csvArray[1];
        this.definition = csvArray[2];
        this.eziologia = csvArray[3];
        this.quadroClinico = csvArray[4];
        this.diagnosi = csvArray[5];
        this.terapia = csvArray[6];
        this.distrettoAnatomico = csvArray[7];
        this.notes = csvArray[8];
    }

    url(): string {
        return `/pathology/${this.code}`;
    }

    render(): string {
        return '';
    }

    icon(): ReactNode {
        switch(this.distrettoAnatomico) {
            case 'Otiti':
                return <OtitiIcon stroke={this.textColor() ?? ''} />
            case 'Alte Vie Respiratorie':
                return <AlteVieRespiratorieIcon stroke={this.textColor() ?? ''} />
            case 'Basse Vie Respiratorie':
                return <InfezioniBasseVieAereeIcon stroke={this.textColor() ?? ''} />
            case 'Sinusite':
            case 'Otite':
            case 'Faringotonsillite':
            case 'Infezioni del Cavo Orale':
                return <ORLIcon stroke={this.textColor() ?? ''} />
            case 'Infezioni della Cute e dei Tessuti Molli':
                return <CuteIcon stroke={this.textColor() ?? ''} />
            case 'Infezioni delle Vie Urinarie':
            case 'Prostatiti':
                return <IVUProstatitiIcon stroke={this.textColor() ?? ''} />
            case 'Infezioni Oculari':
                return <InfezioniOculariIcon stroke={this.textColor() ?? ''} />
            case 'Infezioni Sessualmente Trasmissibili':
                return <InfezioniSessualmenteTrasmissibiliIcon stroke={this.textColor() ?? ''} />
            default:
                return <OtherIcon stroke={this.textColor() ?? ''} />
        }
    }

    id(): string {
        return `pathology-${this.code}`;
    }

    bgColor(): string {
        switch(this.distrettoAnatomico) {
            case 'Otiti':
                return colors.districts.otiti;
            case 'Alte Vie Respiratorie':
                return colors.districts.alteVieRespiratorie;
            case 'Basse Vie Respiratorie':
                return colors.districts.respiratory;
            case 'Sinusite':
            case 'Otite':
            case 'Faringotonsillite':
            case 'Infezioni del Cavo Orale':
                return colors.districts.orl;
            case 'Infezioni Oculari':
                return colors.districts.ocular;
            case 'Infezioni della Cute e dei Tessuti Molli':
                return colors.districts.skin;
            case 'Infezioni Sessualmente Trasmissibili':
                return colors.districts.sti;
            case 'Infezioni delle Vie Urinarie':
            case 'Prostatiti':
                return colors.districts.urinary;
            default:
                return colors.districts.other;
        }
    }

    private textColor(): string {
        return textColor(this.bgColor());
    }
}

export class Pathologies implements ItemManager<Pathology> {
    private items: Pathology[] = [];

    addItem(line: string[]) {
        const pathology = new Pathology(line);
        this.items.push(pathology);
    }

    getItems(): Pathology[] {
        return this.items;
    }

    getById(id: string): Pathology | undefined {
        return this.items.find(item => item.code === id);
    }
}